/**
 * Authoritative operator affordability thresholds.
 *
 * This module is intentionally constants-only so model, SPA, PDF and exports
 * can share the decision boundary without creating an import cycle.
 */
export const OPERATOR_AFFORDABILITY_CAUTION = 0.38;
export const OPERATOR_AFFORDABILITY_CEILING = 0.45;
